import React, { useState, Suspense } from 'react';
import { Box, Tabs, Tab, Typography, CircularProgress, Paper } from '@mui/material';
import AnnouncementsList from '../Components/Lists/AnnouncementsList';

// Lazy-loaded components
const LocationList = React.lazy(() => import("../Components/Lists/LocationList"));
const DistrictList = React.lazy(() => import("../Components/Lists/DistrictList"));
const SemesterList = React.lazy(() => import("../Components/Lists/SemesterList"));
const ScheduleList = React.lazy(() => import("../Components/Lists/ScheduleList"));
const AIAgents = React.lazy(() => import("../Layout/AIAgents"));


// Helper component for tab panel content (remains the same)
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`locations-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `locations-tab-${index}`,
    'aria-controls': `locations-tabpanel-${index}`,
  };
}

const LocationManagement = () => {
  // Local state for the active tab, always defaults to 0 (Admins)
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper elevation={3} sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="locations type tabs" variant="scrollable" scrollButtons="auto">
          <Tab label="Locations" {...a11yProps(0)} />
          <Tab label="District" {...a11yProps(1)} />
          <Tab label="Semester" {...a11yProps(2)} />
          <Tab label="Announcements" {...a11yProps(3)} />
          <Tab label="Schedules" {...a11yProps(4)} />
          <Tab label="AI Agents" {...a11yProps(4)} />

        </Tabs>
      </Box>

      {/* Suspense fallback for lazy loading */}
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
            }}
          >
            <CircularProgress />
            <Typography variant="h6" ml={2}>Loading data...</Typography>
          </Box>
        }
      >
        <TabPanel value={value} index={0}>
          <LocationList />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DistrictList />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <SemesterList />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <AnnouncementsList />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <ScheduleList />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <AIAgents />
        </TabPanel>
      </Suspense>
    </Paper>
  );
};

export default LocationManagement;